export const csvCell = (value) => {
  const text = value === null || value === undefined ? '' : String(value);
  const unsafeText =
    typeof value === 'string' &&
    (/^[=+\-@\t\r\n]/.test(text) || /^\s+[=+\-@]/.test(text)) &&
    !/^-\d+(?:\.\d+)?$/.test(text);
  const safeText = unsafeText ? `'${text}` : text;
  return `"${safeText.replace(/"/g, '""')}"`;
};
